<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.0998 12.4029C16.1998 12.4029 18.7998 9.9029 18.7998 6.7029C18.7998 3.6029 16.2998 1.0029 
    13.0998 1.0029C9.8998 0.902898 7.2998 3.4029 7.2998 6.6029C7.2998 9.8029 9.8998 12.4029 13.0998 12.4029Z"
    fill="#748097"
  />
  <path
    d="M27.9998 16.6028H12.6998C11.6998 16.6028 10.7998 17.4028 10.7998 18.5028V30.0028C10.7998 
    31.0028 11.5998 31.9028 12.6998 31.9028H28.0998C29.0998 31.9028 29.9998 31.1028 29.9998 30.0028V18.5028C29.8998 
    17.4028 29.0998 16.6028 27.9998 16.6028ZM17.0998 27.1028H15.9998L13.5998 23.8028V27.1028H12.2998V21.4028H13.5998L15.9998 
    24.7028V21.4028H17.1998V27.1028H17.0998ZM21.7998 22.6028H19.3998V23.6028H21.7998V24.9028H19.3998V25.9028H21.7998V27.2028H17.8998V21.5028H21.7998V22.6028ZM28.4998 
    26.2028C28.4998 26.8028 27.9998 27.1028 27.5998 27.1028H23.6998C23.0998 27.1028 22.7998 26.6028 22.7998 26.2028V21.4028H24.0998V25.7028H25.0998V22.3028H26.3998V25.7028H27.3998V21.4028H28.6998V26.2028H28.4998Z"
    fill="#009DD6"
  />
  <path
    d="M9.4 17.6028C9.4 16.4028 10.4 15.5028 11.5 15.5028H20.7C19.7 14.9028 18.6 14.6028 17.4 14.6028H8.7C4.9 
    14.6028 2 17.6028 2 21.3028V23.9028C2 24.5028 2.4 24.9028 3 24.9028H9.4V17.6028Z"
    fill="#748097"
  />
</svg>
